import React from 'react';
import PropTypes from 'prop-types';
import MuiAlert from '@material-ui/lab/Alert';

const Alert = (props) => {
    const { elevation, variant, ...rest } = props;
    return (<MuiAlert elevation={elevation} variant={variant} {...rest} />);
};

Alert.propTypes = {
    elevation: PropTypes.number,
    variant: PropTypes.string,
};

Alert.defaultProps = {
    elevation: 6,
    variant: "filled",
};

export default Alert;